import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu, X, Moon, Sun } from "lucide-react"; // pour icônes (tu peux utiliser Heroicons ou FontAwesome aussi)
import { useTheme } from "../Context/ThemeContext";
import { useTranslation } from "react-i18next";

export default function Navbar() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { darkMode, toggleDarkMode } = useTheme();

  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const {t} = useTranslation();
  return (
    <nav className="bg-white shadow p-4  dark:bg-[#706F6F]  text-gray-800 dark:text-white min-h-full relative z-11">
      <div className="flex justify-between items-center max-w-7xl mx-auto">
        <Link to="/">
          <div className="text-xl font-bold dark:bg-white dark:rounded-md">
            {" "}
            <img
              src={require("../logos/WhatsApp_Image_2025-05-26_at_10.32.27-removebg-preview.png")}
              alt=""
            />
          </div>
        </Link>
        <div className="md:flex items-center gap-2 pb-2">
          <button onClick={() => changeLanguage("fr")} className="mx-2"><div className="w-7 h-7">FR<img src={require("../images/téléchargement.png")} alt="Français" /></div></button>
          <button onClick={() => changeLanguage("en")} className="mx-2"><div className="w-[29px] h-[29px]">ENG<img src={require("../images/téléchargement (1).png")} alt="English" /></div></button>
        </div>
        
        {/* Mobile menu button */}
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="md:hidden dark:text-white text-[#706F6F]"
        >
          {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>

        {/* Desktop menu */}
        <div className="hidden md:flex space-x-4 items-center">
          <Link to="/" className="hover:underline">
           {t("nav1")}
          </Link>
          <Link to="/check" className="hover:underline">
            {t("nav2")}
          </Link>
          <Link to="/ChatBox" className="hover:underline">
            {t("nav3")}
          </Link>
           <Link to="/Videos" className="hover:underline">
            {t("nav8")}
          </Link>
          <button onClick={toggleDarkMode} className="ml-2">
            {darkMode ? <Sun size={22} /> : <Moon size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {isMenuOpen && (
        <div className="md:hidden mt-4 space-y-3 flex flex-col items-start px-2">
          <Link
            to="/"
            className="hover:underline"
            onClick={() => setIsMenuOpen(false)}
          >
          {t("nav1")}
          </Link>
          {/* <Link to="/dashboard" className="hover:underline" onClick={() => setIsMenuOpen(false)}>Dashboard</Link> */}
          <Link
            to="/check"
            className="hover:underline"
            onClick={() => setIsMenuOpen(false)}
          >
              {t("nav2")}
          </Link>
          <Link to="/ChatBox" className="hover:underline">
                {t("nav3")}
          </Link>
           <Link to="/Videos" className="hover:underline">
            {t("nav8")}
          </Link>
          {!isAuthenticated && (
            <>
              {/* <Link to="/login" className="hover:underline" onClick={() => setIsMenuOpen(false)}>Connexion</Link>
              <Link to="/Register" className="hover:underline" onClick={() => setIsMenuOpen(false)}>S'enregistrer</Link> */}
            </>
          )}
          <button onClick={toggleDarkMode} className="ml-2">
            {darkMode ? <Sun size={22} /> : <Moon size={22} />}
          </button>
        </div>
      )}
    </nav>
  );
}
